import { createAppRequest } from '../request';
import type { ApiResponse, PageResult, StartupProjectItem } from './startup.api';

const appRequest = createAppRequest();

export async function getStartupProjects(params?: {
  pageNumber?: number;
  pageSize?: number;
  keyword?: string;
  status?: string;
  industry?: string;
  stage?: string;
}): Promise<ApiResponse<PageResult<StartupProjectItem>>> {
  return appRequest('/bff/startup-projects', {
    method: 'GET',
    params,
  });
}

export async function getStartupProjectDetail(
  uuid: string,
): Promise<ApiResponse<StartupProjectItem>> {
  return appRequest(`/bff/startup-projects/${uuid}`, {
    method: 'GET',
  });
}

export async function createStartupProject(
  data: Partial<StartupProjectItem> & { name: string; fundingAmount?: string | null },
): Promise<ApiResponse<StartupProjectItem>> {
  return appRequest('/bff/startup-projects', {
    method: 'POST',
    data,
  });
}

export async function updateStartupProject(
  uuid: string,
  data: Partial<StartupProjectItem> & { fundingAmount?: string | null },
): Promise<ApiResponse<StartupProjectItem>> {
  return appRequest(`/bff/startup-projects/${uuid}`, {
    method: 'PATCH',
    data,
  });
}

export async function archiveStartupProject(
  uuid: string,
): Promise<ApiResponse<StartupProjectItem>> {
  return appRequest(`/bff/startup-projects/${uuid}/archive`, {
    method: 'POST',
  });
}
